import { render } from "./Disclaimers.vue?vue&type=template&id=1f8e60aa&scoped=true&ts=true"
import script from "./Disclaimers.vue?vue&type=script&lang=ts"
export * from "./Disclaimers.vue?vue&type=script&lang=ts"

import "./Disclaimers.vue?vue&type=style&index=0&id=1f8e60aa&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8e60aa"]])

export default __exports__